import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import { Button } from '@/shared/ui/Button/Button'
import { changeDefaultManagerFormScheme } from '../lib/consts'
import { useChangeDefaultManagerForm } from '../lib/use-change-default-manager'
import { SelectField } from '@/shared/ui/FormFields'
import { Loader } from '@mantine/core'

type ChangeDefaultManagerFormProps = {
  onCloseModal: () => void
}

export const ChangeDefaultManagerForm: FC<ChangeDefaultManagerFormProps> = props => {
  const { onCloseModal } = props
  const { t } = useTranslation(['common'])
  const {
    initialValues,
    isLoadingChangeDefaultManager,
    submitForm,
    userListOptions,
    isLoadingUsers,
  } = useChangeDefaultManagerForm(onCloseModal)

  if (isLoadingUsers) {
    return (
      <div className='flex flex-col py-8 items-center justify-center'>
        <Loader size='xs' color='blue' />
      </div>
    )
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitForm}
      validationSchema={changeDefaultManagerFormScheme(t)}
      enableReinitialize
    >
      <Form>
        <div className='flex flex-col w-full mb-4'>
          <SelectField
            name='id'
            label={t('common:library_items.default_manager.name')}
            isSearchable
            disabled={isLoadingChangeDefaultManager}
            options={userListOptions}
            className='flex flex-col w-full min-h-[270px] mb-4'
            required
          />
        </div>
        <div className='flex flex-row w-full'>
          <Button type='submit' size='md' color='base' disabled={isLoadingChangeDefaultManager}>
            {t('common:library_items.default_manager.change_manager')}
          </Button>
        </div>
      </Form>
    </Formik>
  )
}
